
export const getScrollClasses = () => {
  if (typeof window === 'undefined') return "overflow-y-auto";
  const isMobile = window.innerWidth < 768;
  
  if (isMobile) {
    return "overflow-y-visible touch-pan-y"; // Scroll nativo mobile
  } else {
    return "overflow-y-auto scrollbar-thin scrollbar-thumb-slate-300 scrollbar-track-transparent";
  }
};
